var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { FormField } from './form-field';
export var TextAreaField = forwardRef(function (_a, ref) {
    var label = _a.label, error = _a.error, description = _a.description, width = _a.width, _b = _a.isRequired, isRequired = _b === void 0 ? false : _b, _c = _a.labelClassName, labelClassName = _c === void 0 ? '' : _c, tooltip = _a.tooltip, _d = _a.rows, rows = _d === void 0 ? 4 : _d, cols = _a.cols, className = _a.className, props = __rest(_a, ["label", "error", "description", "width", "isRequired", "labelClassName", "tooltip", "rows", "cols", "className"]);
    var id = useId();
    return (_jsx(FormField, { label: label, error: error, description: description, htmlFor: id, labelVariant: 'label', width: width, labelClassName: labelClassName, tooltip: tooltip, containerClassName: width !== null && width !== void 0 ? width : 'w-full', isRequired: isRequired, children: _jsx("textarea", __assign({ ref: ref, id: id, rows: rows, cols: cols, className: "!w-full !px-2 !py-1 !text-gray-700 !rounded-md hover:!border-vjwPrimary focus:!outline-none focus:!border-vjwPrimary focus:!border-2 disabled:!cursor-not-allowed disabled:!opacity-50 !shadow-none\n                    !border !border-gray-300\n                ".concat(error ? '!border-vjwDanger focus:!border-vjwDanger' : '!border-gray-300 focus:!border-vjwPrimary', " \n                ").concat(className || '') }, props)) }));
});
TextAreaField.displayName = 'TextAreaField';
